import React, { Component } from 'react';
import { eventCheck } from '../../helpers/misc-javascript-helpers';
import './pager-styles.css';

class PagerComponentAsync extends Component {
    constructor(props) {
        super(props);
        this.fieldRef = React.createRef();
        this.state = {
            currentPage: 1,
            lastPage: 0,
            meta: {},
            pagerInput: this.props.updateInput
        };
        this.updateTick = 0;
    }

    componentDidMount() {
        this.updateMetaState();
    }

    componentDidUpdate() {
        if (this.updateTick === 0) {
            this.updateTick++;
            const setPage = this.state.currentPage === '' ? '' : this.props.meta.current_page;
            this.setState({ currentPage:  setPage });
            setTimeout(() => {
                this.updateTick = 0;
            }, 1);
        }
    }

    /** Handles setting numerical input as the current page. */
    handlePageInput(e) {
        eventCheck(e);
        let currPage = 0;
        if (isNaN(e.target.value) || e.target.value.length === 0) {
            currPage = '';
            this.setState({ currentPage: '' });
        } else {
            if (e.target.value >= 1 && e.target.value <= this.props.meta.last_page) {
                currPage = parseInt(e.target.value, 10);
                this.setState({ currentPage: currPage });
            } else {
                currPage = 1;
                this.setState({ currentPage: currPage });
            }
        }
        this.props.updateOutput({ action: 'field-input', currentPage: currPage, lastPage: this.props.meta.last_page });
        this.selectValue();
    }

    /** Handles setting first page as the current page.*/
    goToFirst(e) {
        eventCheck(e);
        this.setState({ currentPage: 1 });
        this.props.updateOutput({ action: 'to-first', currentPage: 1, lastPage: this.props.meta.last_page });
    }

    /** Handles setting last page as the current page.*/
    goToLast(e) {
        eventCheck(e);
        this.setState({ currentPage: parseInt(this.state.lastPage) });
        this.props.updateOutput({ action: 'to-last', currentPage: parseInt(this.props.meta.last_page, 10), lastPage: this.props.meta.last_page });
    }

    /** Handles the effect of clicking on the previous button.*/
    handlePreviousClick(e) {
        eventCheck(e);
        let currPage = 0;
        if ((this.state.currentPage - 1) < 1) {
            currPage = parseInt(this.state.currentPage, 10);
            this.setState({ currentPage: currPage });
        } else {
            currPage = parseInt(this.state.currentPage -= 1, 10);
            this.setState({ currentPage: currPage });
        };
        this.props.updateOutput({ action: 'to-previous', currentPage: currPage, lastPage: this.props.meta.last_page });
    }

    /** Handles the effect of clicking on the next button.*/
    handleNextClick(e) {
        eventCheck(e);
        let currPage = 0;
        if ((this.state.currentPage + 1) > this.state.lastPage) {
            currPage = parseInt(this.state.currentPage, 10);
            this.setState({ currentPage: currPage });
        } else {
            currPage = parseInt(this.state.currentPage += 1, 10);
            this.setState({ currentPage: currPage });
        };
        this.props.updateOutput({ action: 'to-next', currentPage: currPage, lastPage: this.props.meta.last_page });
    }

    /** Handles setting meta data state update/ sync.*/
    updateMetaState() {
        if (this.props.meta) {
            this.setState({
                meta: this.props.meta,
                lastPage: this.props.meta.last_page,
                currentPage: this.props.meta.current_page
            });
        }
    }

    /** Selected the input field value/ content. */
    selectValue(e) {
        eventCheck(e);
        if (this.fieldRef.current) {
            this.fieldRef.current.select();
        }
    }

    handleFocusTarget(topLeft, topRight, inputField) {
        return { topLeft, topRight, inputField };
    }

    render() {
        return (
            <React.Fragment>
                {typeof this.props.updateInput !== 'undefined' ?
                    <div className="pager__row row mrml-0">
                        <div className="pagination__block layout m0-auto">
                            <ul className="pagination__list v-pagination">
                                <li>
                                    <button onClick={(e) => this.goToFirst(e)} type="button" className="pagination__dot btn to-first" aria-label="First Page"
                                        disabled={this.props.updateInput.prevBtnState}>
                                        <i className="fas fa-caret-left" aria-hidden="true"></i>
                                        <i className="fas fa-caret-left" aria-hidden="true"></i>
                                    </button>
                                </li>
                                <li>
                                    <button onClick={(e) => this.handlePreviousClick(e)} type="button" className="pagination__dot btn to-previous" aria-label="Previous Page"
                                        disabled={this.props.updateInput.prevBtnState}>
                                        <i className="fas fa-caret-left" aria-hidden="true"></i>
                                    </button>
                                </li>
                                <li>
                                    <div className="pagination__input__wrapper">
                                        <input name="num_field" onChange={(e) => this.handlePageInput(e)} ref={this.fieldRef}
                                            type="text" className="pagination__input__field" value={this.state.currentPage} onFocus={(e) => this.selectValue(e)} onClick={(e) => this.selectValue(e)} />
                                    </div>
                                </li>
                                <li>
                                    <button onClick={(e) => this.handleNextClick(e)} type="button" className="pagination__dot btn to-next" aria-label="Next Page" disabled={this.props.updateInput.nextBtnState}>
                                        <i className="fas fa-caret-right" aria-hidden="true"></i>
                                    </button>
                                </li>
                                <li>
                                    <button onClick={(e) => this.goToLast(e)} type="button" className="pagination__dot btn to-last" aria-label="Last Page"
                                        disabled={this.props.updateInput.nextBtnState}>
                                        <i className="fas fa-caret-right" aria-hidden="true"></i>
                                        <i className="fas fa-caret-right" aria-hidden="true"></i>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    : ''}
            </React.Fragment>
        );
    }
}

export default PagerComponentAsync;